import React, { useContext, useEffect, useState, useCallback } from "react";
import { Backdrop, CircularProgress, Theme, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RouterProvider, useLocation } from "react-router-dom";
import PublicAppRoutes from "./routes/public-app-routes";
import "./config/i18n";
import ErrorComponent from "./components/error/error";
import SuccessComponent from "./components/success/SuccessComponent";
import pubSub, { EVENTS } from "./config/pubSub";
import { AppConfig } from "./context/context";
import { parseLanguage } from "./utils/utils";


function PublicApp() {
  const [open, setOpen] = useState<boolean>(false);
  const [showLongLoadingMessage, setShowLongLoadingMessage] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    pubSub.subscribe(EVENTS.PROGRESS, (status: boolean) => setOpen(status));
  }, []);

  useEffect(() => {
    let timer: any;
    if (open) {
      timer = setTimeout(() => {
        setShowLongLoadingMessage(true);
      }, 2000);
    } else {
      setShowLongLoadingMessage(false);
    }
    return () => clearTimeout(timer);
  }, [open]);

  return (
    <>
      <Backdrop sx={{ zIndex: 9999, color: "var(--kyocera-white)", flexDirection: "column" }} open={open}>
        <CircularProgress color="inherit" />
        {showLongLoadingMessage && (
          <>
            <Typography variant="h5" sx={{ mt: 4, fontWeight: "bold" }}>{t("processing")}</Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>{t("pleasewait")}</Typography>
          </>
        )}
      </Backdrop>
      <ErrorComponent />
      <SuccessComponent />
      <RouterProvider router={PublicAppRoutes} />  
    </>
  );
}

export default PublicApp;
